<template>
  <body>
    <main>
      <section class="">
        <div class="search-page-header-container">
          <div class="goback">
            <a href="javascript:;" @click="goback">
              <img class="arrow-icon" :src="arrowLeft" alt="" /> Go back
            </a>
          </div>
          <div class="search-title">
            Search institution members and their ePortfolios
          </div>
          <div class="home-hero-search-input">
            <span class="home-search-input-icon">
              <i class="fa fa-search"></i>
            </span>
            <input
              type="text"
              id="memberSearchInput"
              class="j-search-input"
              placeholder="Search by name, skills, badges, or showcases"
            />
            <ul id="searchFilterDropdown" class="dropdown">
              <li>
                <a
                  href="javascript:;"
                  data-type="user_name"
                  class="j-search-type search-filter-dropdown-option"
                  >Search members <strong>named</strong> "<span
                    class="search-term"
                  ></span
                  >".</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  data-type="user_skill_tags"
                  class="j-search-type search-filter-dropdown-option"
                  >Search members with "<span class="search-term"></span>"
                  <strong>skills</strong>.</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  data-type="user_badge_keys"
                  class="j-search-type search-filter-dropdown-option"
                  >Search members from "<span class="search-term"></span>"
                  <strong>badges</strong>.</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  data-type="showcases"
                  class="j-search-type search-filter-dropdown-option"
                  >Search members from "<span class="search-term"></span>"
                  <strong>showcases</strong>.</a
                >
              </li>
            </ul>
          </div>
          <p style="margin-bottom: 3rem;">
            <strong>Note:</strong> You may only see ePortfolios that were made
            visible to public. Employers, school admission officers,
            instructors, and classmates may see more detailed ePortfolios.
          </p>
        </div>

        <div class="view" v-if="!(showCaseList.length > 0)">
          <button id="rowsBtn" class="active-view" @click="clickRows">
            <i class="fa fa-bars"></i>
          </button>
          <button id="colsBtn" @click="clickCols">
            <i class="fa fa-th"></i>
          </button>
        </div>

        <ul
          class="search-results-container-rows show j-row-wrapper"
          id="rows"
        ></ul>

        <div class="search-results-container-columns" id="cols">
          <ul class="search-results-cols-grid j-col-wrapper">
            <!-- <li>
                                <a :href="redirectUrl" class="list-item-showcase" target="_blank">
                                    <div class="list-item-showcase__top" :style="{ 'background-image': 'url(' + bgURL + ')' }"></div>
                                    <div class="list-item-showcase__bottom">
                                        <h5>{{ item.title }}</h5>
                                        <p>
                                            {{ item.summary_text }}
                                        </p>
                                    </div>
                                </a>
                            </li> -->
          </ul>
        </div>
        <ul
          class="search-results-cols-grid j-col-wrapper2 showcaseid"
          v-if="showCaseList.length"
        >
          <li v-for="(item, index) in showCaseList" :key="index">
            <div
              class="list-item-showcase"
              @click="jumpShowCase(item.model)"
              target="_blank"
            >
              <img
                class="list-item-showcase__top"
                :src="
                  item.model.summary_picture_attachment
                    ? item.model.summary_picture_attachment.view_url
                    : ''
                "
                alt=""
              />
              <div class="list-item-showcase__bottom">
                <h5>{{ item.model.title }}</h5>
                <p>
                  {{ item.model.summary_text }}
                </p>
              </div>
            </div>
          </li>
        </ul>
        <i
          class="j-loading fa fa-spinner fa-pulse"
          style="display: none; font-size: 32px; color: #808388; margin-top: 10px;"
        ></i>
      </section>
    </main>
  </body>
</template>

<script>
import { CN_BRAND, CN_HOST } from "@/configs";
import _ from "lodash";

export default {
  name: "search",
  data() {
    return {
      arrowLeft: require("@/assets/img/tabler_icon_arrow.png"),
      showCaseList: [],
      userDefaultBg: require("@/assets/img/user-theme-bg.png"),
    };
  },
  mounted() {
    var that = this;

    function getRowGridItemTemplate() {
      return `
    <li class="search-result-row">
        <a href="${CN_HOST}/{{=it.model.cn_number}}" target="_blank" class="btn-link" style="color: black;">
            {{? it.model.profile.theme_home_banner_url}}
                <div class="rows-cover-image" style="background-image: url('{{=it.model.profile.theme_home_banner_url}}.h140.jpg')"></div>
            {{?? it.model.institution_setting.ui_profile_cover_attachment_url}}
                <div class="rows-cover-image" style="background-image: url('{{=it.model.institution_setting.ui_profile_cover_attachment_url}}.h140.jpg')"></div>
            {{??}}
                <div class="rows-cover-image" style="background-image: url('${CN_HOST}/img/common/profile-bg/2.png')"></div>
            {{?}}
        </a>
            {{? it.model.profile_institutions && it.model.profile_institutions.length}}
                <div class="institution-logos-row">
                    {{~it.model.profile_institutions :v:k}}
                        <div class="search-result-institution-logo">
                            <img src="{{=v.logo}}" alt="{{=v.name}}">
                        </div>
                    {{~}}
                </div>
            {{?}}
           
            <div class="bottom-row">
                <a href="${CN_HOST}/{{=it.model.cn_number}}" target="_blank" class="btn-link" style="color: black;">
                <div class="search-results-row-col-left">
                <div class="search-results-row-user-avatar" style="background-image: url('{{=it.model.avatar.view_url}}')"></div>

                {{? it.model.imported_by_conexus_id}}
                <div class="search-results-row-certified" style="margin-top:10px;">
                    <i class="fa fa-check-circle certified-icon" style="margin-right:10px;"></i>Certified
                </div>
                {{?}}
                </div>
            </a>
                <div class="search-results-row-col-mid">
                    <a href="${CN_HOST}/{{=it.model.cn_number}}" target="_blank" class="btn-link" style="color: black;">
                <h2 class="search-results-row-name">
                    {{=it.model.display_name}}
                </h2>
            </a>
            <a href="${CN_HOST}/{{=it.model.cn_number}}" target="_blank" class="btn-link" style="color: black;">
                <p>{{=it.model.profile.headline}}</p>
            </a>
                {{?it.model.skill_tags && it.model.skill_tags.length}}
                    <div class="user-skills">
                       <div class="text-left">
                            <span class="user-skills-title">Skills:</span>
                            {{~it.model.skill_tags :tag:index}}
                            <a
                              class="user-skills-text-token"
                              href="javascript:;"
                              title="{{=tag}}"
                            >
                              <span class="omit max-width-100">{{=tag}}</span>
                            </a>
                          {{~}}
                      </div>
                    </div>
                {{?}}
                {{?it.model.badges && it.model.badges.length}}
                    <div class="user-badges">
                        {{~it.model.badges :value:index}}
                            <img class="user-badge-item" src="{{=value.logo}}" data-cnname="{{=it.model.url}}" data-bagdeid="{{=value.id}}" alt="{{=value.name}}">
                        {{~}}
                        
                    </div>
                {{?}}
                </div>
                <a href="${CN_HOST}/{{=it.model.cn_number}}" target="_blank" class="btn-link" style="color: black;">
                <div class="search-results-row-col-right">
                    {{? it.model.country && it.model.country.flag_url}}
                    <div class="search-results-row-user-flag">
                        <img src="{{=it.model.country.flag_url}}" alt="{{=it.model.country.name}}">
                    </div>
                    {{?}}
                </div>
            </a>
            </div>

    </li>`;
    }

    function getColGridItemTemplate() {
      return `<li class="search-result-item search-result-item-col">
                <div>
                    <a href="${CN_HOST}/{{=it.model.cn_number}}" target="_blank" class="btn-link banner-container" style="color: black;">
            {{? it.model.profile.theme_home_banner_url}}
              <img src="{{=it.model.profile.theme_home_banner_url}}.h156.jpg"/>
            {{?? it.model.institution_setting.ui_profile_cover_attachment_url}}
              <img src="{{=it.model.institution_setting.ui_profile_cover_attachment_url}}.h156.jpg"/>
            {{??}}
              <img src="{{=it.userDefaultBg}}"/>

            {{?}}
        </a>
            <div class="search-result-item-content">
                <a href="${CN_HOST}/{{=it.model.cn_number}}" target="_blank" class="btn-link" style="color: black;">
                <div class="user-avatar">
                    {{? it.model.profile_institutions && it.model.profile_institutions.length}}
                        <div class="user-institution">
                            {{~it.model.profile_institutions :v:k}}
                                {{? v.institution_conexus_id}}
                                    <img src="{{=v.logo}}" alt="{{=v.name}}">
                                {{?}}
                            {{~}}
                        </div>
                    {{?}}

                    <div class="user-avatar-img" style="background-image: url('{{=it.model.avatar.view_url}}');"></div>

                    {{? it.model.country && it.model.country.flag_url}}
                    <div class="user-flag">
                        <img src="{{=it.model.country.flag_url}}" alt="{{=it.model.country.name}}">
                    </div>
                    {{?}}
                </div>
            </a>
                <div class="user-info" style="margin-bottom: .5rem;">
                    <h2 class="user-name">
                        {{=it.model.display_name}}
                        {{? it.model.imported_by_conexus_id}}
                            <small><i class="fa fa-check-circle certified-icon"></i></small>
                        {{?}}
                    </h2>
                    <div style="margin-bottom: .5rem;" class="user-headline">
                        <div>
                        {{=it.model.profile.headline}}
                        </div>
                        </div>
                        {{?it.model.skill_tags && it.model.skill_tags.length}}
                            <div class="user-skills">
                                <div class="user-skills-text">
                                <span class="user-skills-title">Skills:</span>
                                  {{~it.model.skill_tags :tag:index}}
                                    <a
                                      class="user-skills-text-token"
                                      href="javascript:;"
                                      title="{{=tag}}"
                                    >
                                      <span class="omit max-width-100">{{=tag}}</span>
                                    </a>
                                  {{~}}
                                </div>
                            </div>
                        {{?}}
                        {{?it.model.badges && it.model.badges.length}}
                    <div class="user-badges">
                        {{~it.model.badges :value:index}}
                            <img class="user-badge-item" src="{{=value.logo}}" data-cnname="{{=it.model.url}}" data-bagdeid="{{=value.id}}" alt="{{=value.name}}">
                        {{~}}
                        
                    </div>
                {{?}}
                    </div>
                </div>
                </div>
      </li>`;
    }

    window.$(document).ready(function() {
      var offset = 0;
      var limit = 10;
      var defaultSearchType = "user_name";
      var $loading = $(".j-loading");
      var $rowWrapper = $(".j-row-wrapper");
      var $colWrapper = $(".j-col-wrapper");
      var $colWrapper2 = $(".j-col-wrapper2");
      var $searchInput = $(".j-search-input");
      $searchInput.focus();
      const noResultHint = "No members were found. Try another search.";

      function requestSearchUser(options = {}, callback = function() {}) {
        //  *     'keyword'=>'string, the search keyword',
        //  *     'search_mode'=>'string, user_name|user_skill_tags|institution_name|country_name',
        //  *     'order_field'=>'score_of_profile|last_active_time',
        //  *     'order'=> 'int, 0|1, default is 0',
        const { keyword, mode, offset, limit } = options;
        $.ajax({
          dataType: "json",
          url: CN_HOST + "/api/site_brand_search_user",
          data: {
            keyword: keyword,
            search_mode: mode,
            site_brand: CN_BRAND,
            order_field: "score_of_profile",
            with_user_institution_setting: 1,
            exclude_site_brand_users: 0,
            offset: offset,
            limit: limit,
            with_user_profile: 1,
            with_user_country: 1,
            with_user_skill_tags: 1,
          },
          beforeSend: function() {
            $loading.show();
          },
          complete: function() {
            $loading.hide();
          },
        }).done(callback);
      }

      function requestSearchUserSection(
        options = {},
        callback = function() {},
      ) {
        //  *     'keyword'=>'string, the search keyword',
        //  *     'search_mode'=>'string, user_name|user_skill_tags|institution_name|country_name',
        //  *     'order_field'=>'score_of_profile|last_active_time',
        //  *     'order'=> 'int, 0|1, default is 0',
        const { keyword, offset, limit } = options;
        $.ajax({
          dataType: "json",
          url: CN_HOST + "/api/site_brand_search_user_section",
          data: {
            keyword: keyword,
            site_brand: CN_BRAND,
            with_user_section_summary_picture_attachment: 1,
            offset: offset,
            limit: limit,
          },
          beforeSend: function() {
            $loading.show();
          },
          complete: function() {
            $loading.hide();
          },
        }).done(callback);
      }

      function renderItems(items) {
        $.each(items, (k, item) => {
          item.userDefaultBg = that.userDefaultBg;
          $rowWrapper.append(doT.template(getRowGridItemTemplate())(item));
          $colWrapper.append(doT.template(getColGridItemTemplate())(item));
        });
        that.bindJumpBadge();
      }

      $(document).on("keyup", ".j-search-input", function(e) {
        toggleSearchFilterDropdown(e);
        $(".j-search-type").removeClass("actived");
        var $selected = $(
          '.j-search-type[data-type="' + defaultSearchType + '"]',
        );
        if ($selected.length) {
          $selected.addClass("actived");
        }
      });

      $(document).on("keydown", ".j-search-input", function(event) {
        var keyword = $.trim($(this).val());
        if (!!keyword && defaultSearchType && 13 === event.which) {
          var $selected = $(
            '.j-search-type[data-type="' + defaultSearchType + '"]',
          );
          if ($selected.length) {
            $selected.trigger("click");
            $(this).trigger("blur");
          }
        }
      });

      $(document).on("click", ".j-search-type", function() {
        that.showCaseList = [];
        defaultSearchType = $(this).attr("data-type");
        $(window).stopScrollPagination();
        $rowWrapper.empty();
        $colWrapper.removeClass("grid-col-1").empty();
        var offset = 0;
        var limit = 30;
        var type = defaultSearchType;
        var keyword = $.trim($searchInput.val());
        if (type == "showcases") {
          requestSearchUserSection(
            {
              keyword: keyword,
              offset: offset,
              limit: limit,
            },
            function(res) {
              if (!res.result || !res.data || !res.data.length) {
                $colWrapper
                  .addClass("grid-col-1")
                  .append(`<li style="text-align:center">${noResultHint}</li>`);
                return;
              }

              // renderItems(res.data);
              that.showCaseList = res.data;

              var isEnabled = true;
              var isEmptyData = false;
              $(window).scrollPagination({
                getScrollTarget: function() {
                  return $rowWrapper.hasClass("show")
                    ? $rowWrapper
                    : $colWrapper;
                },
                load: function() {
                  if (isEmptyData) {
                    return;
                  }
                  if (!isEnabled) {
                    return;
                  }

                  offset = offset + limit;
                  requestSearchUserSection(
                    {
                      keyword: keyword,
                      offset: offset,
                      limit: limit,
                    },
                    function(res) {
                      isEnabled = true;
                      if (!res.data.length) {
                        $colWrapper.append(
                          `<li style="text-align:center">No more</li>`,
                        );
                        isEmptyData = true;
                        return;
                      }
                      this.showCaseList = this.showCaseList.concat(res.data);
                    },
                  );

                  isEnabled = false;
                },
              });
            },
          );

          return;
        }

        if (!keyword) return;
        requestSearchUser(
          {
            mode: type,
            keyword: keyword,
            offset: offset,
            limit: limit,
          },
          function(res) {
            if (!res.result || !res.data || !res.data.length) {
              $rowWrapper.append(
                `<li style="text-align:center">${noResultHint}</li>`,
              );
              $colWrapper
                .addClass("grid-col-1")
                .append(`<li style="text-align:center">${noResultHint}</li>`);
              return;
            }

            renderItems(res.data);

            var isEnabled = true;
            var isEmptyData = false;
            $(window).scrollPagination({
              getScrollTarget: function() {
                return $rowWrapper.hasClass("show") ? $rowWrapper : $colWrapper;
              },
              load: function() {
                if (isEmptyData) {
                  return;
                }
                if (!isEnabled) {
                  return;
                }

                offset = offset + limit;
                requestSearchUser(
                  {
                    keyword: keyword,
                    mode: type,
                    offset: offset,
                    limit: limit,
                  },
                  function(res) {
                    isEnabled = true;
                    if (!res.data.length) {
                      $rowWrapper.append(
                        `<li style="text-align:center">No more</li>`,
                      );
                      $colWrapper.append(
                        `<li style="text-align:center">No more</li>`,
                      );
                      isEmptyData = true;
                      return;
                    }
                    renderItems(res.data);
                  },
                );

                isEnabled = false;
              },
            });
          },
        );
      });
    });
  },
  methods: {
    clickRows() {
      if (!document.getElementById("rows").classList.contains("show")) {
        document.getElementById("rows").classList.add("show");
        document.getElementById("cols").classList.remove("show");
        document.getElementById("rowsBtn").classList.add("active-view");
        document.getElementById("colsBtn").classList.remove("active-view");
      }
    },

    clickCols() {
      if (!document.getElementById("cols").classList.contains("show")) {
        document.getElementById("cols").classList.add("show");
        document.getElementById("rows").classList.remove("show");
        document.getElementById("colsBtn").classList.add("active-view");
        document.getElementById("rowsBtn").classList.remove("active-view");
      }
    },
    goback() {
      this.$router.go(-1);
    },
    jumpShowCase(item) {
      window.open(
        `${CN_HOST}/${_.get(
          item,
          "user.cn_number",
        )}?section=showcase&section_id=${item.id}`,
      );
    },
    bindJumpBadge() {
      $(".user-badge-item").one("click", (e) => {
        var badgeId = $(e.currentTarget).data("bagdeid");
        var cnname = $(e.currentTarget).data("cnname");

        window.open(`${CN_HOST}${cnname}?section=badge&section_id=${badgeId}`);
      });
    },
  },
};
</script>

<style lang="scss">
.search-page-header-container {
  margin: auto;
}

.arrow-icon {
  display: inline-block;
  height: rem(24);
  margin-right: rem(3);
}

.goback {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: rem(14);
  line-height: rem(19);
  color: #3574d9;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.search-title {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: rem(24);
  line-height: rem(33);
  margin: rem(10) 0;
}

.list-item-showcase {
  &__top {
    background: #d8d8d8 no-repeat center;
    background-size: cover;
    background-position: 50% 50%;
    height: rem(140);
  }
  &__bottom {
    width: auto;
    height: rem(170);
    padding: rem(10) rem(15);
    p {
      max-height: rem(110);
      overflow: auto;
      font-size: rem(14);
      line-height: 1.2;
    }
  }
  &:hover {
    text-decoration: none;
  }
  box-shadow: 0 rem(2) rem(4) 0 $cn-gray;
  background-color: $white;
  color: initial;
  display: block;
  margin: 0 auto rem(20) auto;
  width: rem(270);
  cursor: pointer;
}

.user-badges {
  display: flex;
  flex-wrap: wrap;
  img {
    width: rem(30);
    margin-top: rem(5);
    object-fit: fill;
    margin-left: rem(5);
  }
}

.search-result-item-col {
  .user-info {
    max-width: 328px;
  }
  .banner-container {
    border-radius: rem(12) rem(12) 0 0;
    overflow: hidden;
    max-width: 358px;
    img {
      height: rem(125);
      object-fit: cover;
    }
  }
  .user-name {
    font-size: rem(20);
    font-weight: 700;
    line-height: rem(27);
    color: #393939;
    text-align: center;
  }
  .user-headline {
    font-weight: 400;
    font-size: rem(14);
    line-height: rem(20);
    color: #3c3c3c;
  }
}
.user-headline {
  height: rem(50);
  overflow: hidden;
  > div {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
.user-skills {
  height: 5.81rem;
  overflow: hidden;
  -webkit-box-orient: unset;

  > div {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
.user-skills-title {
  margin-top: rem(25);
  margin-bottom: 0;
  font-weight: 600;
  font-size: rem(14);
  line-height: rem(20);
  color: black;
}
.user-skills-text {
  &-token {
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    padding: 10px 15px;
    margin: 5px 5px 5px 0;
    border-radius: 16px;
    height: auto;
    line-height: rem(12);
    background: #efeff9;
    color: #639de9;
    border: none;
    font-size: rem(12);
  }
}
</style>
